import React from "react"
import './style.scss'
import Cookies from 'js-cookie'
import userStore from '~/redux/user/store'
import connect from "~/tools/connect";
import { getTabToShow, addCssDynamically, getPrimaryColor, getPrimaryNavigation } from "~/tools/tabNavBarMethods"
import accessLevelCheck from '~/tools/accessLevelCheck'
import { iconsToShow } from "./iconsToShow"
import { ellipsifyByChar } from '~/tools/strings/ellipsify'
class TabNavBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: Cookies.get('tab_id') || "/",
            primaryColor: getPrimaryColor() || "#ffffff",
            primaryNavigation: getPrimaryNavigation() || [],
            tabsToShow: getTabToShow() || 4
        }
    }

    componentDidMount() {
        this.setState({id: window && window.location && window.location.pathname})
        addCssDynamically()
    }

    handleClick = (event) => {
        this.setState({ id: event.target.id })
        Cookies.set('tab_id', event.target.id)
    }

    render() {
        const tabsToShow = this.state.tabsToShow ? this.state.tabsToShow : 4
        const color = this.state.primaryColor
        let primary = this.state.primaryNavigation
        primary = primary.filter((primary) => {
            if (primary.url && accessLevelCheck(this.state.user)(primary)){
                return true
            } else return false;
        })
        const primaryComponent = primary ? primary.slice(0, tabsToShow).map((primary,index) => {
            return (<div key={index} className={`tabnavbar-item`}>
                <a className="anchor-tag" href={primary.url} id={primary.url} onClick={this.handleClick}>
                    {primary.icon ? iconsToShow(primary, color, this.state.id) : <div className="div-height"></div>}
                    <div
                        className="tabnavbar-title"
                        style={{ color: this.state.id === primary.url ? color : "#ffffff" }}
                    >
                        {ellipsifyByChar(primary.title, 14)}
                    </div>
                </a>
            </div>)
        }) : <div></div>
        return (
            <div className="TabNavBar">
                <div className="tabnavbar-container">
                    {primaryComponent}
                </div>
            </div>
        )
    }
}

connect(TabNavBar, (state) => ({ user: state.user }), userStore)

export default TabNavBar;